import Dashboard from './Dashboard';
import People from './People';

export { People };
export default Dashboard;
